import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useDisconnectZoomInfo(tenant: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axios.delete(`${getBongoUrl()}/v1/org/${tenant}/integrations/zoominfo`);
    },
    onSuccess: () => {
      queryClient.setQueryData(['zoominfo', tenant], false);
    },
  });
}
